import { StatusBadge } from '@/components/common'
import { DOCUMENT_STATUS_LABEL, DOCUMENT_STATUS_TONE, expiryPhrase } from '../types'
import type { DocumentStatus } from '../types'

export interface DocumentStatusBadgeProps {
  status: DocumentStatus
  daysUntilExpiry?: number | null
  /** Appends "expires in 45 days" beside the badge. */
  withPhrase?: boolean
}

/**
 * Status as a colour, with the number of days beside it rather than inside it.
 *
 * <p>The badge answers "is there a problem"; the phrase answers "how urgent". Putting the
 * count inside the badge makes every badge a different width, and a column of ragged pills
 * is harder to scan than a column of identical ones — which is the whole job of this screen.
 */
export function DocumentStatusBadge({ status, daysUntilExpiry, withPhrase }: DocumentStatusBadgeProps) {
  return (
    <span className="inline-flex items-center gap-2">
      <StatusBadge status={status} tone={DOCUMENT_STATUS_TONE[status]} label={DOCUMENT_STATUS_LABEL[status]} />
      {withPhrase && daysUntilExpiry != null && (
        <span className="text-xs text-[var(--color-muted)]">
          {status === 'EXPIRED' ? expiryPhrase(daysUntilExpiry) : `expires ${expiryPhrase(daysUntilExpiry)}`}
        </span>
      )}
    </span>
  )
}
